import React from 'react';
import { ListTile } from '@thd-olt-component-react/list-tile';

import proptypes from 'prop-types';

const {
  arrayOf, number, shape, string, bool, func
} = proptypes;

const ListsCompactList = ({
  lists, maxMobileListSize, iconSize, isDashboardSnapshot, onTileClick
}) => {
  return (
    <div data-testid="lists-compact-list" className="sui-flex sui-flex-col sui-gap-3 sui-mb-7">
      {lists?.slice(0, maxMobileListSize).map((list, index) => (
        <ListTile
          iconSize={iconSize}
          key={index + list.id}
          listId={list.id}
          data={list}
          numberOfThumbnails={3}
          enableSharedIcon
          position={index}
          impressionName="ListsActiveState"
          impressionComponent="Lists"
          isDashboardSnapshot={isDashboardSnapshot}
          onClick={onTileClick}
        />
      ))}
    </div>
  );
};

ListsCompactList.propTypes = {
  maxMobileListSize: number,
  lists: arrayOf(shape({
    id: string,
    name: string,
    url: string,
    itemCount: number,
    listAccessType: string,
    images: arrayOf(shape({
      url: string
    }))
  })),
  iconSize: string,
  isDashboardSnapshot: bool,
  /** Called as (listId, position, source) when a tile's name or thumbnail link is clicked. */
  onTileClick: func
};

ListsCompactList.defaultProps = {
  maxMobileListSize: 4,
  iconSize: 'small',
  lists: [],
  isDashboardSnapshot: false,
  onTileClick: undefined
};

export default ListsCompactList;
